import events from '../events/events';

const Flash = {};

/**
 * Flash plugin
 *
 * @param Vue
 * @param options
 */
Flash.install = function(Vue, options)
{
    let methods =
    {
        /**
         * Show flash and set content
         *
         * @param {String} headline
         * @param {String} content
         * @param {Function} callback
         */
        show(headline, content, callback)
        {
            this.headline = '';
            this.content = '';
            this.callback = '';

            if (arguments.length == 2 && typeof arguments[1] == 'function')
            {
                this.content = headline;
                this.callback = content;
            }
            else if (arguments.length == 1)
            {
                this.content = headline;
            }
            else
            {
                this.headline = headline;
                this.content = content;
                this.callback = callback;
            }

            // push flash on event bus
            events.$emit('flash.open', this.headline, this.content, this.callback);
        },
    };

    // register global methods
    Vue.flash = methods;

    // register instance methods
    Vue.prototype.$flash = methods;
};

export default Flash;



// WEBPACK FOOTER //
// ./src/js/plugins/flash.js